import { render, staticRenderFns } from "./financeiro-upload-nota-fiscal.vue?vue&type=template&id=32b4aa0a&scoped=true"
import script from "./financeiro-upload-nota-fiscal.vue?vue&type=script&lang=ts"
export * from "./financeiro-upload-nota-fiscal.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-upload-nota-fiscal.vue?vue&type=style&index=0&id=32b4aa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4aa0a",
  null
  
)

export default component.exports